import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceContractDetail } from 'modules/suppliers/types';

// export type ContractDetail = typeof schemas.ContractDetailFromKios._type;
export type ContractDetail = ReplaceContractDetail;

interface UseSupplyContractDetailsProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
  contractOperationCode?: string;
}

const useSupplyContractDetails = (props: UseSupplyContractDetailsProps) => {
  const { supplierProfileOperationCode, customerOperationCode, contractOperationCode } = props;

  const service = useService();

  return useQuery({
    queryKey: ['supplyContractDetails', customerOperationCode],
    queryFn: async () => {
      try {
        if (
          !service ||
          !customerOperationCode ||
          !supplierProfileOperationCode ||
          !contractOperationCode
        ) {
          return null;
        }

        const res: ContractDetail = await service.SupplierProfileController_getContractDetail({
          params: {
            customerOperationCode,
            supplierProfileOperationCode,
            contractOperationCode,
          },
        });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useSupplyContractDetails;
